import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import $ from 'jquery';
import { getRequestSubdomain } from '../../utils/tenant';

const ForgotPassword = () => {
  const navigate = useNavigate();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const DefaultAppId = process.env.REACT_APP_DEFAULT_APP_ID;

  const [loginMethod, setLoginMethod] = useState('email'); // 'email' | 'whatsapp'
  const [inputValue, setInputValue] = useState('');
  const [error, setErrorMessage] = useState('');
  const [errors, setErrors] = useState({});

  const validateInput = () => {
    if (loginMethod === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(inputValue);
    } else {
      const phoneRegex = /^[0-9]{10}$/;
      return phoneRegex.test(inputValue);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setErrors({});

    if (!validateInput()) {
      setErrorMessage(
        loginMethod === 'email'
          ? 'Please enter a valid email address'
          : 'Please enter a valid 10-digit WhatsApp number'
      );
      return;
    }

    setErrorMessage('');

    const userData = {
      whatsAppNo: loginMethod === 'whatsapp' ? inputValue : '',
      email: loginMethod === 'email' ? inputValue : '',
      accountVerificationType: loginMethod === 'email' ? 1 : 2,
      accountId: DefaultAppId,
      subdomain: getRequestSubdomain(),
    };

    const url = `${apiBaseUrl}/Auth/forget-email-password`;

    $.ajax({
      url: url,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify(userData),
      success: function (response) {
        if (response.success && response.data) {
          setErrorMessage('');
          navigate('/verifyotp', {
            state: {
              email: loginMethod === 'email' ? inputValue : '',
              whatsappNo: loginMethod === 'whatsapp' ? inputValue : '',
              actionType: 'forgotpassword',
              verificationMethod: userData.accountVerificationType
            },
          });
        } else {
          setErrorMessage(response.data?.errorMessage || 'Unexpected error');
        }
      },
      error: function (response) {
        debugger;
        const errorData = response.responseJSON;

        // Prefer message or errors[0] if available
        let errorMessage = "An error occurred.";

        if (errorData?.message) {
          errorMessage = errorData.message;
        } 

        let formattedErrors = {};
          if (Array.isArray(response.responseJSON.errors)) {
            response.responseJSON.errors.forEach(errObj => {
                formattedErrors = { ...formattedErrors, ...errObj };
              });
          }

          setErrors(formattedErrors);

          setErrorMessage(errorMessage);
      },
    });
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (loginMethod === 'whatsapp') {
      if (/^\d*$/.test(value)) {
        setInputValue(value);
      }
    } else {
      setInputValue(value);
    }
  };

  const handleLoginMethodChange = (e) => {
    const value = e.target.value;
    setLoginMethod(value);
    setInputValue('');
    setErrorMessage('');
  };

  return (
    <div className="bg-light py-5">
      <Container className="bg-white rounded shadow p-4">
        <Row className="align-items-center">
          <Col md={6} className="text-center">
            <img
              src="/assets/images/login-illustration.png"
              alt="Login Illustration"
              className="img-fluid rounded mb-3"
              style={{ maxHeight: '300px' }}
            />
            <p className="text-muted fs-5">Let us help you grow..</p>
          </Col>

          <Col md={6}>
            <div className="p-3">
              <h2 className="fw-bold mb-2 d-flex align-items-center gap-2">
                Forgot Password ?
                <img src="/assets/images/logo.png" alt="Logo" width="50" />
              </h2>              
              <h6>We need to verify,it's you using 2FA</h6>
               {error && (
                    <div className="text-danger mb-1 fw-semibold" style={{ fontSize: '0.9rem' }}>
                      {error}
                    </div>
                  )}
              <br />
              <p>
                How do you want to get the 2FA Code
              </p>

              <Form.Group className="mb-3">
                <div className="mb-2">
                  <Form.Check
                    label="Email"
                    value="email"
                    name="loginMethod"
                    type="radio"
                    checked={loginMethod === 'email'}
                    onChange={handleLoginMethodChange}
                  />
                </div>
                <div>
                  <Form.Check
                    label="WhatsApp"
                    value="whatsapp"
                    name="loginMethod"
                    type="radio"
                    checked={loginMethod === 'whatsapp'}
                    onChange={handleLoginMethodChange}
                  />
                </div>
              </Form.Group>



              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="inputField">
                  <Form.Label>
                    {loginMethod === 'email' ? 'Email Address' : 'WhatsApp Number'}
                    <span style={{ color: 'red' }}>*</span>
                  </Form.Label>

                  {loginMethod === 'whatsapp' ? (
                    <InputGroup>
                      <InputGroup.Text>+91</InputGroup.Text>
                      <Form.Control
                        type="text"
                        maxLength="10"
                        value={inputValue}
                        onChange={handleInputChange}
                        required
                        isInvalid={!!errors.WhatsAppNo}
                      />
                    </InputGroup>
                  ) : (
                    <Form.Control
                      type="email"
                      value={inputValue}
                      onChange={handleInputChange}
                      required
                      isInvalid={!!errors.Email}
                    />
                  )} 
                  {loginMethod === 'whatsapp' ? (
                    <Form.Control.Feedback type="invalid">
                        {errors.WhatsAppNo}
                    </Form.Control.Feedback> ) : (
                      <Form.Control.Feedback type="invalid">
                        {errors.Email}
                    </Form.Control.Feedback>
                  )}             
                </Form.Group>

                <Button
                  type="submit"
                  className="w-100 text-white fw-semibold"
                  style={{
                    backgroundColor: '#CC5500',
                    border: 'none',
                  }}
                >
                  Continue
                </Button>
              </Form>

              <p className="mt-3 text-center">
                Don’t have an account? <a href="/signup" className="text-primary">Sign up</a>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;
